import { render, staticRenderFns } from "./TaskVideoMedia.vue?vue&type=template&id=9ddcac88&scoped=true"
import script from "./TaskVideoMedia.vue?vue&type=script&lang=js"
export * from "./TaskVideoMedia.vue?vue&type=script&lang=js"
import style0 from "./TaskVideoMedia.vue?vue&type=style&index=0&id=9ddcac88&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddcac88",
  null
  
)

export default component.exports